import { DataGrid } from '@mui/x-data-grid';
import { Box } from '@mui/material';
import { useSelector } from 'react-redux';
import ProductActions from './ProductActions';
import CustomPagination from '../../../components/customPagination';
import { useGetProductsHandler } from '../dataHandlers/getProductsHandler';
import { currencyFormatter } from '../../../utils/currencyFormat';

const ProductsTable = ({ searchQuery = {}, handlePaginationChange }) => {
  const taxTypes = useSelector((state) => state.taxTypes.taxTypes);
  const codes = useSelector((state) => state.uomCodes.uomCodes);

  const { products, totalDocuments, isLoading } = useGetProductsHandler({ searchQuery });

  const columns = [
    {
      field: 'description',
      headerName: 'Description',
      flex: 2,
    },
    {
      field: 'unit_of_measure',
      headerName: 'UOM',
      flex: 1,
      valueGetter: (params) => {
        return codes.find((option) => option.Code === params)?.Name;
      },
    },
    {
      field: 'unit_rate',
      headerName: 'Unit Price',
      flex: 1,
      renderCell: (params) => {
        return `${currencyFormatter().format(params.row.unit_rate)} `;
      },
    },
    {
      field: 'taxes',
      headerName: 'Tax Category',
      flex: 1,
      valueGetter: (params) => {
        if (!params.length) {
          return '';
        }
        return taxTypes.find((type) => type.Code === params[0].category)?.Description;
      },
    },
    {
      field: 'taxes_value',
      headerName: 'Tax Value',
      flex: 1,
      renderCell: (params) => {
        return `${params.row.taxes[0].value}${params.row.taxes[0].type === 'percentage' ? '%' : ''}`;
      },
    },
    {
      field: 'actions',
      headerName: 'Actions',
      flex: 0.5,
      sortable: false,
      renderCell: (params) => {
        return <ProductActions product={params.row} />;
      },
    },
  ];

  return (
    <Box>
      <DataGrid
        loading={isLoading}
        rows={products}
        columns={columns}
        getRowId={(row) => row.product_id}
        paginationMode="server"
        rowCount={totalDocuments}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
        pageSizeOptions={[10, 25]}
        disableRowSelectionOnClick
        onPaginationModelChange={(model) => {
          handlePaginationChange(model.page + 1, model.pageSize);
        }}
        slots={{
          pagination: CustomPagination,
        }}
      />
    </Box>
  );
};

export default ProductsTable;
